<div class="ImageUpload">
  <h2>Upload New Image</h2>
  <smartflip-property-image
    [imgUrl]="imgUrl"
    [useUpload]="false"
    class="ImageUpload__Image"
  ></smartflip-property-image>

  <form [formGroup]="imageForm">
    <input
      id="imgUrl"
      name="imgUrl"
      [formControlName]="'imgUrl'"
      type="file"
      (change)="detectFiles($event)"
    />
    <ion-button
      fill="clear"
      class="ImageUpload__TooltipButton"
      (click)="presentTooltip()"
    >
      Upload button not working?
    </ion-button>

    <div class="ImageUpload__ButtonWrapper">
      <ion-button
        class="ImageUpload__Button"
        fill="outline"
        color="medium"
        (click)="cancelUpload()"
      >
        Cancel
      </ion-button>
      <ion-button
        class="ImageUpload__Button"
        [ngClass]="{ 'ImageUpload__Button--disabled': !imageForm.dirty }"
        fill="solid"
        color="primary"
        (click)="startUpload()"
      >
        Upload
      </ion-button>
    </div>
  </form>
</div>
